<template>
  <main class="text-center">
    <h5 class="m-3">eBay Options</h5>
	<div class="text-left">
		<label>Script</label>
		<select v-model="torun" class="form-control mb-2">
			<option value="addItems">Add Items</option>
			<option value="updateItems">Update Items</option>
			<option value="syncEbayItems">Sync Items</option>
			<option value="deleteItems">Delete Items</option>
			<option value="doAll">Do All</option>
		</select>
		<label>Locale</label>
		<select v-model="locale" class="form-control mb-2">
			<option>US</option>
			<option>US2</option>
			<option>UK</option>
			<option>UK2</option>
			<option>UK3</option>
			<option>UK4</option>
		</select>
		<label>Limit</label>
		<input type="number" v-model="limit" class="form-control mb-2" />
	</div>
	<button class="btn btn-primary" v-on:click.prevent="start">Start</button>
  </main>
</template>

<script>
	export default {
		name: 'EbayOptions',
		data: function() {
			return {
				locale: 'US',
				torun: 'addItems',
				limit: 100
			};
		},
		methods: {
			start: function() {
				if (!confirm('Please confirm script start.')) return;
	
				this.$notify({
					group: 'main',
					title: 'Started.',
					text: 'Connecting to eBay.',
					type: 'success',
				});
	
				this.$axios.post(`/script`, {script: 'ebay', torun: this.torun, locale: this.locale, limit: this.limit})
					.then((response) => {
						 console.log(response.data.data);
					})
					.catch((error) => {
						console.log(error);
						this.$notify({
							group: 'main',
							title: 'Error.',
							text: 'The ebay script has failed.',
							type: 'warn',
						});
					})
					.finally(()=>{
						//
					});
			},
		},
	};
	</script>
